module.exports = __webpack_public_path__ + "img/didpanel.4e3a1461.jpg";